import * as React from "react";
import classNames from "classnames";
import { useMemo } from "react";

interface Props {
  title: React.ReactElement | string,
  checked: boolean,
  setChecked: (checked: boolean) => void,
  disabled?: boolean,
  labelClassName?: string,
}

export function BoxHeaderOption({title, checked, setChecked, disabled, labelClassName}: Props) {
  const onChange = useMemo(() => {
    return setChecked ? (e) => setChecked(e.target.checked) : undefined
  }, [setChecked]);
  const readOnly = !onChange;
  return (
    <label className={classNames(labelClassName)}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} readOnly={readOnly} />
      <span>show {title}</span>
    </label>
  )
}